import { Interp, css } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Publish({ v }) {
  if (!v.showPublish) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeDialog}>
        <div className="gp-venster" onClick={v.stopProp} style={{ "width": "min(440px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px", "boxSizing": "border-box" }}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <span style={{ "fontSize": "20px", "flex": "0 0 auto" }}>
              🎺
            </span>
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              Op de paal plakken
            </div>
            <button onClick={v.closeDialog} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          <div>
            {' '}
            <div style={{ "fontSize": "13px", "fontWeight": "600", "height": "19px", "marginBottom": "5px" }}>
              Titel
            </div>
            {' '}
            <input type="text" value={v.publishTitle ?? ''} onInput={v.onTitleInput} placeholder="Geef je krabbel een naam" />
            {' '}
          </div>
          <button onClick={v.toggleThemeMatch} className="gp-btn" style={css(v.themeBtnStyle)}>
            {' '}
            <span style={css(v.themeBoxStyle)}>
              {' '}
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.1" strokeLinecap="round" strokeLinejoin="round">
                <path d="m5 12.5 4.5 4.5L19 7" style={css(v.themeCheckStyle)} />
              </svg>
              {' '}
            </span>
            {' '}
            <span style={{ "display": "flex", "flexDirection": "column", "alignItems": "flex-start", "lineHeight": "1.2", "minWidth": "0", "marginLeft": "9px" }}>
              <span style={{ "fontSize": "14px", "fontWeight": "700" }}>
                Past bij het thema
              </span>
              <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
                {"Thema van vandaag: "}
                <Interp v={v.themeWord} />
              </span>
            </span>
            {' '}
          </button>
          {v.hasPublishError ? (<>
            <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600" }}>
              <Interp v={v.publishError} />
            </div>
          </>) : null}
          <button onClick={v.doPublish} className="gp-btn pink" disabled={v.publishing} style={css(v.hoofdKnopStyle)}>
            <Interp v={v.publishBtnLabel} />
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
